import {Component, OnInit, ViewChild, Input} from '@angular/core';
import {LeftpanelComponent, LoaderWithProgressComponent, PromoteToEnvironmentComponent} from '../leftpanel/leftpanel.component';
import {ConfService} from '../conf.service';
import {EndpointComponent, GithubConnectionComponent} from '../manage-entities/manage-entities.component';
import {MatDialog} from '@angular/material';
import {environment} from '../../environments/environment';
import {Router} from '@angular/router';
import {AccountInfoService} from '../user/account-info.service';
import {FormControl} from '@angular/forms';
import {MethodTypes} from '../dataaccessapi/dataaccessapi.component';

@Component({
    selector: 'app-data-analytics',
    templateUrl: './data-analytics.component.html',
    styleUrls: ['./data-analytics.component.scss']
})
export class DataAnalyticsComponent implements OnInit {
    @Input() partner = localStorage.getItem('partner');
    @Input() account = localStorage.getItem('account');
    @Input() partnerKey = localStorage.getItem('partnerKey');
    totalNumberOfPlans = 0;
    countOfEnterPriseSearchPlans = 0;
    countPartnerPlans: any = 0;
    maxCount: any = 10;
    itemList = [];
    settings = {
        text: 'Select attribute(s) to search instantly',
        selectAllText: 'Select All',
        unSelectAllText: 'Unselect All',
        enableSearchFilter: true,
        autoPosition: false
    };
    filterData: any[];
    searchText: string;
    searchText1: string;
    gatewayUrl: any;
    DeleteEntityCheck = true;
    item = [];
    columns = ['Plan Name', 'Database Type', 'Database Connection', 'Database Name', 'Table Name'];
    componentLoading = true;
    resultLoading = false;
    dbLoading = false;
    resultPanelOpened = false;
    createNewPanelOpened = false;
    mode = new FormControl('over');
    plans: any;
    selectedPlan: any;
    searchResult: any;
    srcURL: any;


    planName = '';
    version = '';
    category = '';
    description = '';
    dbConnections: any = [];
    selectedDbConnection: any;
    databases: any = [];
    selectedDatabase: any;
    tables: any = [];
    selectedTables: any;
    loading = false;
    loading1 = false;
    settings1 = {
        text: 'Select tables *',
        // selectAllText: 'Select All',
        // unSelectAllText: 'Unselect All',
        enableSearchFilter: true,
        autoPosition: false
    };


    // @ViewChild('aceEditor') editor:any;

    constructor(public platform: LeftpanelComponent,
                public accountInfoService: AccountInfoService,
                private confPost: ConfService,
                public dialog: MatDialog,
                public router: Router) {
    }

    ngOnInit() {
        if (this.platform.loadingForTheFirstTime === true && this.platform.loadingForTheFirstTimeCompleted === false) {
            this.platform.initialisePlatform();
        }
        this.getDataAnalyticsPlans();
    }

    async getDataAnalyticsPlans() {
        this.componentLoading = true;
        const payload = {
            partner: this.partner,
            account: this.account,
            pkey: this.partnerKey
        };
        this.confPost.getDataAnalyticsPlans(payload).subscribe(data => {
            const res: any = data;
            if (res) {
                this.plans = res;
                this.componentLoading = false;
            }

        }, err => {
            this.platform.handleErrorGracefully(err, 'Error while retrieving plans.');
            this.componentLoading = false;
            this.router.navigateByUrl('/controlplane');
        });

    }

    runPlan(item) {
        this.selectedPlan = item;
    }

    editPlan(item) {

    }

    deletePlan(item) {

    }

    createPlan() {
        this.getDbConnections();
    }

    addPlan() {
        if (this.planName !== '') {
            if (this.selectedDbConnection) {
                if (this.selectedDatabase) {
                    if (this.selectedTables) {
                        let temp: any = [];
                        for (const item of this.selectedTables) {
                            temp.push(item.itemName);
                        }
                        const payload = {
                            'planName': this.planName,
                            'databaseName': this.selectedDatabase,
                            'databaseConnectionName': this.selectedDbConnection.database_name,
                            'partner': this.partner,
                            'databasetype': this.selectedDbConnection.database_type,
                            'pkey': this.partnerKey,
                            'tables': temp
                        };
                        // console.log(payload);
                        const loaderDialog = this.dialog.open(LoaderWithProgressComponent, {
                            maxWidth: '95vw',
                            maxHeight: '60vh',
                        });
                        this.confPost.postDataAnalyticsPlan(payload).subscribe(res => {
                            loaderDialog.close();
                            this.getDataAnalyticsPlans();
                            this.createNewPanelOpened = false;
                        }, err => {
                            loaderDialog.close();
                            this.platform.handleErrorGracefully(err, 'Error while adding data analytics plan');
                        });

                    } else {
                        this.platform.handleErrorGracefully('', 'Please select atleast one table');
                    }
                } else {
                    this.platform.handleErrorGracefully('', 'Please select database');
                }
            } else {
                this.platform.handleErrorGracefully('', 'Please select database connection');
            }
        } else {
            this.platform.handleErrorGracefully('', 'Please enter all the required fields');
        }
    }

    getDbConnections() {
        this.dbLoading = true;
        this.confPost.getDatabasesForPartner(this.partner, this.partnerKey).subscribe(data => {
            const res: any = data;
            // console.log(res);
            if (res) {
                // this.dbConnections = res.body;
                for (const db of res.body) {
                    if (db.database_type === 'mysql' || db.database_type === 'sqlserver') {
                        this.dbConnections.push(db);
                    }
                }
                this.dbLoading = false;
            }

        }, err => {
            this.platform.handleErrorGracefully(err, 'Error while retrieving database connections.');
            this.dbLoading = false;
            // this.router.navigateByUrl('/data-analytics');
        });
    }

    getDatabases() {
        if (this.selectedDbConnection) {
            this.loading = true;
            this.confPost.getDatabasesForAConnection(this.partner, this.selectedDbConnection['database_name'], this.selectedDbConnection['database_type']).subscribe(data => {
                const res: any = data;
                this.loading = false;
                // console.log(res);
                if (res) {
                    this.databases = res;
                    this.selectedDatabase = undefined;
                    this.selectedTables = undefined;
                }

            }, err => {
                this.loading = false;

                this.platform.handleErrorGracefully(err, 'Error while retrieving databases.');
            });
        }
    }

    getTables() {
        if (this.selectedDatabase) {
            this.tables = [];
            this.loading1 = true;

            this.confPost.getDatabaseTablesForAConnection(this.partner, this.selectedDbConnection['database_name'], this.selectedDbConnection['database_type'], this.selectedDatabase).subscribe(data => {
                const res: any = data;
                this.loading1 = false;

                if (res) {
                    for (const table of res) {
                        const obj = {
                            id: table,
                            itemName: table
                        };
                        this.tables.push(obj);
                    }
                }

            }, err => {
                this.loading1 = false;
                this.platform.handleErrorGracefully(err, 'Error while retrieving tables.');
            });
        }
    }

    promoteAPI(item) {
        this.dialog.open(PromoteToEnvironmentComponent, {
            height: '40%',
            width: '30%',
            data: {partner: this.partner, account: this.account, entity: item.entityname, version: item.version, type: 'ENTERPRISESEARCH'}
        });
    }

    openGitHubDialog(partner, account, entityname, version, type) {
        const dialogRef = this.dialog.open(GithubConnectionComponent, {
            minWidth: '30vw',
            data: {
                partner: partner,
                account: account,
                entityname: entityname,
                version: version,
                type: type
            }
        });
    }


    openDialog(partner, account, entity, version): void {
        const data = {};
        data['partner'] = partner;
        data['account'] = account;
        data['entity'] = entity;
        data['version'] = version;
        data['url'] = this.gatewayUrl;
        data['partnerKey'] = this.partnerKey;
        data['type'] = 'entity';
        const dialogRef = this.dialog.open(EndpointComponent, {
            width: '80%',
            height: '80%',
            data: data,
        });

        dialogRef.afterClosed().subscribe(result => {
        });
    }

    getCreatedDate(val) {
        // const data = val.split('#');
        // if (Number(data[2]) !== 0) {
        //     return new Date(Number(data[2])).toLocaleString();
        // } else {
        //     return new Date(Date.now() - Number(this.getTotalUptime(val)) * 1000 * 60 * 60).toLocaleString();
        // }

        if (val) {
            return this.platform.timeConverter(val);
        } else {
            return '';
        }

    }

    getLastModifiedData(val, val1) {
        if (val) {
            return this.platform.timeConverter(val);
        } else {
            if (val1) {
                return this.platform.timeConverter(val1);
            } else {
                return '';
            }
        }
    }

    getVersion(val) {
        if (val) {
            /* var str = Object.values(val).toString();
         return str.substr(str.indexOf('.') + 1, str.length);*/
            const data = val.split('#');
            return data[1];
        }
    }

    refreshBillingForPartnerAccount() {
        this.confPost.refreshBillingForPartnerAccount(localStorage.getItem('partner'), localStorage.getItem('account')).subscribe(data => {
            this.platform.openSnackBar('Refreshed the duration of API Availability for this account successfully', 'Success', {
                duration: 5000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        }, error => {
            this.platform.openSnackBar('Error while refreshing the duration of API Availability', 'Error', {
                duration: 5000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        });
    }

    checkFilter() {
        if (!this.filterData || this.filterData === [] || this.filterData === null) {
            alert('Please select an attribute to filter.');
            this.searchText = '';
        }
    }

    reset() {
        this.selectedPlan = undefined;
        this.searchResult = undefined;
        this.srcURL = undefined;
    }

    getChart() {
        if (this.searchText1 && this.searchText1 !== '') {
            const payload = {
                tableInfo: this.selectedPlan.tableInfo,
                databaseName: this.selectedPlan.databaseName,
                databaseConnectionName: this.selectedPlan.databaseConnectionName,
                partner: this.partner,
                pkey: this.partnerKey,
                databaseType: this.selectedPlan.databasetype,
                message: this.searchText1
            };
            this.searchResult = undefined;
            this.srcURL = undefined;
            this.resultLoading = true;
            this.confPost.getDashboChartId(payload).subscribe(data => {
                this.resultLoading = false;
                // console.log(data);
                this.searchResult = data;
                this.srcURL = this.searchResult['upsertedId'];
                // this.editor.value = data;

            }, err => {
                this.platform.handleErrorGracefully(err, 'Error while searching text. Please try again later');
                this.resultLoading = false;

            });

        } else {
            this.platform.handleErrorGracefully('', 'Please enter text to search');
        }
    }

    stringifyJson(val) {
        if (val != null) {
            return JSON.stringify(val, null, 2).trim();
        } else {
            return val;
        }
    }

    getTableNames(tableInfo) {
        let tablename = [];
        for (const table of tableInfo) {
            tablename.push(table.table_name);
        }
        return tablename;
    }

}
